/**
 * Multi-tenant session checks (slug + clinic payload from GET /api/clinic/{slug}).
 */

export function slugEquals(a, b) {
    if (a == null || b == null) return false;
    return String(a).toLowerCase().trim() === String(b).toLowerCase().trim();
}

/**
 * True if the stored Sanctum user belongs to the clinic identified by `slug` / `clinic.id_klinik`.
 */
export function isSessionForClinic(user, clinic, slug) {
    if (!user || !clinic || !slug) return false;
    const role = String(user.role || "")
        .toLowerCase()
        .trim();
    if (role === "super") return false;

    if (role === "admin") {
        return slugEquals(user.klinik?.slug, slug);
    }

    if (role === "doctor") {
        if (slugEquals(user.dokter?.klinik?.slug, slug) || slugEquals(user.klinik?.slug, slug)) {
            return true;
        }
        const dk = user.dokter?.id_klinik;
        const ck = clinic.id_klinik;
        if (dk != null && ck != null && Number(dk) === Number(ck)) return true;
        return false;
    }

    if (role === "user") {
        const pid = user.pasien?.id_klinik;
        const ck = clinic.id_klinik;
        if (pid != null && ck != null && Number(pid) === Number(ck)) return true;
        // Demo tenant only: slug "careline" + pasien tanpa id_klinik (tidak terikat klinik nyata)
        if (
            slugEquals(slug, "careline") &&
            (pid == null || Number(pid) === 0)
        ) {
            return true;
        }
        return false;
    }

    return false;
}

/**
 * Role-based home inside this tenant (patient queue lives at /:slug/careline).
 */
export function getTenantDashboardPath(user, slug) {
    const role = String(user.role || "")
        .toLowerCase()
        .trim();
    if (role === "admin") {
        const s = user.klinik?.slug || slug;
        return `/${s}/clinic-admin`;
    }
    if (role === "doctor") {
        const s = user.dokter?.klinik?.slug || user.klinik?.slug || slug;
        return `/${s}/dashboard/doctor`;
    }
    if (role === "user") {
        return `/${slug}/careline`;
    }
    if (role === "super") {
        return "/super-admin";
    }
    return `/${slug}`;
}
